import { render, staticRenderFns } from "./AtendimentoEnfermagemItem.vue?vue&type=template&id=7072d9a8&scoped=true&"
import script from "./AtendimentoEnfermagemItem.vue?vue&type=script&lang=js&"
export * from "./AtendimentoEnfermagemItem.vue?vue&type=script&lang=js&"
import style0 from "./AtendimentoEnfermagemItem.vue?vue&type=style&index=0&id=7072d9a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7072d9a8",
  null
  
)

export default component.exports